/**
 * 创建数组.
 * @param {Number} startNum 数组起始值
 * @param {Number} length 数组长度
 * @param {bool} 是否倒序
 * @return {array}
 */
export function createNumArray(startNum, length, isReverse) {
  if (!length) return;
  startNum = parseInt(startNum);
  length = parseInt(length);

  let arr = [];
  for (let i = startNum; i < length + startNum; i++) {
    arr.push(i);
  }

  if (isReverse) {
    arr = arr.reverse();
  }

  return arr;
}

/**
 * 判断年份是否为闰年.
 * @param {Number} year 年份
 * @return {bool} true：闰年；false：非闰年
 */
export function isLeapYear(year) {
  if (!year) return;
  year = parseInt(year);
  if (year % 4 !== 0) {
    return false;
  } else {
    if ((year % 100 === 0) && (year % 400 !== 0)) {
      return false;
    }
    return true;
  }
}

/**
 * 创建月份数组.
 * @return {array}
 */
export function createMonthsArr() {
  return createNumArray(1, 12);
}

/**
 * 创建当月天数数组.
 * @param {number} year 年份
 * @param {number} month 月份
 * @return {array}
 */
export function createDaysArr(year, month) {
  if (!month) return;
  year = parseInt(year);
  month = parseInt(month);

  if (month > 12) return [];

  if (month === 2) {
    if (isLeapYear(year)) {
      return createNumArray(1, 29);
    }
    return createNumArray(1, 28);
  }

  if ([1, 3, 5, 7, 8, 10, 12].indexOf(month) >= 0) {
    return createNumArray(1, 31);
  }

  return createNumArray(1, 30);
}


// WEBPACK FOOTER //
// ./common/Utils/timeUtil.js